import React, { AriaAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import s from './AllButton.scss';

export interface Props {
  'aria-hidden'?: AriaAttributes['aria-hidden'];
}

const AllButton: React.FC<Props> = ({ 'aria-hidden': ariaHidden }) => {
  const { t } = useTranslation();
  return (
    <div className={s['root']} aria-hidden={ariaHidden}>
      <img
        src="https://st.deviantart.net/eclipse/global/svg/all-button.svg?1"
        alt={t('browseHeader.page.all')}
      />
    </div>
  );
};
AllButton.displayName = 'AllButton';

export default AllButton;
